import { useEffect, useRef, useState } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../redux/store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePrevious = (value: any) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};

export const useIsMobile = () => {
    const [width, setWidth] = useState<number>(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    return width <= 1023;
};

export const useHideWebsiteFooter = () => {
    useEffect(() => {
        // Hide website footer
        const footer = document.querySelector('.footer');
        if (footer && footer instanceof HTMLElement) {
            footer.style.display = 'none';
        }

        return () => {
            if (footer && footer instanceof HTMLElement) {
                footer.style.display = 'block';
            }
        };
    }, []);
};

export const useBrowserBackClickHandler = (callback: () => void) => {
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        window.onpopstate = function () {
            window.history.go(1);
            callback();
        };

        return () => {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            window.onpopstate = () => {};
        };
    }, [callback]);
};

export interface AppRoutes {
    [key: string]: string;
}

export const useRoutesWithLang = <T>(routes: AppRoutes) => {
    const result: AppRoutes = {};
    const languagePrefix = mapLanguageForRoute();
    for (const [key, path] of Object.entries(routes)) {
        result[key] = `${languagePrefix}/${path}`;
    }

    return result as T;
};

export const mapLanguageForRoute = () => {
    const language = window.GLOBALS?.language;
    if (language) {
        switch (language) {
            case 'ru':
                return '';
            case 'uk':
                return '/ua';
            default:
                return `/${language}`;
        }
    }

    return '';
};
